__webpack_require__.p = "https://admin.windrises.com/";